<template>
  <el-dialog :title="isEdit?'编辑字典':'添加字典'"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="500px">
    <el-form class="widget-form" :model="dictionary" label-width="80px" size="medium">
      <el-form-item prop="category" label="分类:">
        <el-select v-model="dictionary.categoryId" placeholder="请选择分类类型">
          <el-option
              v-for="item in categories"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="name" label="维度名称:">
        <el-input type="text" v-model="dictionary.name" placeholder="请输入维度名称"></el-input>
      </el-form-item>
      <el-form-item prop="introduce" label="维度介绍:">
        <el-input type="textarea" v-model="dictionary.introduce" placeholder="请输入维度介绍"></el-input>
      </el-form-item>

      <div class="sign">选择因子</div>
      <table class="table table-bordered margin-tb-10 font-xs">
        <tr class="bg-light-cyan">
          <th width="90">维度</th>
          <th>因子</th>
        </tr>
        <tr v-for="item in degrees" :key="item.id">
          <td valign="middle">{{ item.degree }}</td>
          <td>
            <el-checkbox-group v-model="factorList">
              <el-checkbox v-for="f in item.factor" :label="f">{{ f }}</el-checkbox>
            </el-checkbox-group>
          </td>
        </tr>
      </table>
    </el-form>
    <div slot="footer">
      <el-button @click="doClose" size="small"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="submit()" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { get, findDegrees, save, update, findCategory } from '@/api/rep/dictionary'

export default {
  computed: {
    ...mapGetters(['user', 'company']),
    isEdit() {
      return this.dictionaryId
    }
  },
  props: {
    visible: false,
    dictionaryId: null
  },
  data: function() {
    return {
      dictionary: {},
      factorList: [],
      degrees: [],
      categories: []
    }
  },
  methods: {
    init() {
      this.findDegrees()
      this.findCategory()
      if (this.dictionaryId) {
        this.getDictionary()
      } else {
        this.dictionary = {}
        this.factorList = []
      }
    },
    getDictionary() {
      get(this.dictionaryId).then(res => {
        this.dictionary = res.data.result
        this.factorList = this.dictionary.contents
        console.info(this.factorList)
      })
    },
    findDegrees() {
      findDegrees().then(res => {
        this.degrees = res.data.result
        console.info(this.degrees)
      })
    },
    findCategory() {
      findCategory().then(resp => {
        this.categories = resp.data.result
      })
    },
    doClose() {
      this.$emit('done', false)
    },
    submit() {
      this.dictionary.contents = this.factorList
      let category = this.categories.filter(o=>o.id === this.dictionary.categoryId)
      if(category){
        this.dictionary.categoryName = category[0].name
      }

      if (this.dictionaryId) {
        update(this.dictionary).then(res => {
          this.$message.success('保存成功')
          this.$emit('done', true)
        })
      } else {
        save(this.dictionary).then(res => {
          this.$message.success('保存成功')
          this.$emit('done', true)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sign {
  font-weight: bold;

  &:before {
    content: ' ';
    border-right: 4px solid #4381e6;
    margin-right: 8px;
  }
}
</style>
